<template>
    <el-dialog title="选择工程师" :visible.sync="visible" width="70%" @close="closeDialog" :close-on-click-modal="false"
        append-to-body>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange(page)"
                @selection-change="handleSelectionChange" @size-change="pageSizeChange" @current-change="pageChange">
            </avue-crud>
        </basic-container>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="confirmSelection">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { engineerBindingListOption } from "./engineerBindingListOption";
import { getShopBindingList } from "@/api/work/waterProject/purWaterGoods";
export default {
    name: "ShopSelector",
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            tableOption: engineerBindingListOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            loading: false,
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10, //每页显示多少条
            },
        };
    },
    created() {
        this.handleList();
    },
    methods: {
        handleList() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize,
            };
            this.downloadData = params;
            getShopBindingList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = this.page.currentPage;
            params.size = pageSize;
            this.downloadData = params;
            getShopBindingList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize,
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;
            this.downloadData = params;
            getShopBindingList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            this.tableLoading = true;
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            getShopBindingList(params).then((res) => {
                if (res.code != 500) {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size,
                    };
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                    this.tableData = [];
                }
            });
        },
        //eslint-disable-next-line
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            this.downloadData = params;
            getShopBindingList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        handleSelectionChange(selection) {
            this.selectedShops = selection;
        },
        confirmSelection() {
            this.$emit("confirmEngineerSelector", this.selectedShops);
            this.resetSelection();
            this.$emit("update:visible", false);
        },
        closeDialog() {
            this.$emit("update:visible", false);
        },
        resetSelection() {
            this.selectedProducts = [];
            this.handleList();
        },
    },
};
</script>

<style scoped>
.filter-bar {
    margin-bottom: 20px;
    display: flex;
    gap: 10px;
}

.filter-item {
    flex: 1;
}

.dialog-footer {
    text-align: right;
}
</style>